import styled from "styled-components";

import {
  alignItemsCenter,
  bp,
  flexSpBetween,
  media,
  rem,
} from "@styles/Utilities.styled";


export const StyledFooter = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-block: 0.7rem;
  background-color: var(--clr-primary-700);
  color: var(--clr-gray-200);
  font-size: ${rem(13)};
  z-index: 10;

  .footer-content {
    padding-inline: 1rem;
    ${flexSpBetween}

    p {
      ${alignItemsCenter}

      span :not(.dismissable) {
        color: var(--clr-white);
      }

      span {
        &.dismissable-copyright {
          display: none;

          ${media(rem(730))} {
            display: inline;
          }
        }

        &.dismissable-name {
          display: none;

          ${media(bp.medium)} {
            display: inline;
          }
        }
      }

      svg {
        width: ${rem(15)};
        margin-inline: 0.5rem;
      }

      a {
        transition: color 0.2s;

        &:hover {
          color: var(--clr-white);
        }
      }
    }
  }
`;
